module.exports = "/img/caret-right-app.png?16d65fd143239cbea2c6a803a4eba5ff";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-right-app.png
// module id = VdoR
// module chunks = 76